import create from 'zustand';
import mixpanel from 'lib/analytics/mixpanel';

export const [useDubSurvey] = create(set => ({
  isModalSummaryOpen: false,
  surveyResponse: null,

  setSurveyResponse: (response: string) => {
    set({ surveyResponse: response });
  },
  openModalSummary: () => {
    mixpanel.track('component_impression', {
      component: 'dubbed talks survey'
    });
    set({ isModalSummaryOpen: true });
  },

  closeAllModal: () => {
    set({ isModalSummaryOpen: false });
  }
}));
